module.exports = __webpack_public_path__ + "static/media/add-user-img.0d7a92db.svg";